<template>
  <app-main-layout>
    <!--  -->
    <!-- Main Left Menu  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <!-- Main Top Menu -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-page-header
            icon="el-icon-left"
            title="Startups"
            :content="count !== undefined ? `${count} Startups` : ''"
          >
          </el-page-header>
        </template>
        <template v-slot:center>
          <span>
            <!-- Search -->
          </span>
        </template>
        <template v-slot:right>
          <!-- Other buttons -->
        </template>
      </app-top-nav>
    </template>
    <!--  -->
    <!-- Main Content -->
    <template v-slot:main>
      <!--  -->
      <!-- Charts -->
      <!--  -->
      <!-- Loaded businesses -->
      <div app-main-content>
        <BusinessesList :loading="loading"  :businesses="businesses"></BusinessesList>
      </div>
    </template>
    <!--  -->
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import BusinessesList from "./components/businesses-list.component.vue";

@Options({
  components: { BusinessesList },
})
export default class extends Vue {
  /**
   * @returns businesses
   */
  get businesses() {
    return this.$store.state.businesses.businesses;
  }

  /**
   * @returns businesses
   */
  get loading() {
    return this.$store.state.businesses.loading;
  }

  get count() {
    return this.$store.state.businesses.count ?? "-";
  }

  mounted() {
    this.$store.dispatch("businesses/fetch");
  }
}
</script>

<style lang="scss"></style>
